// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u8xBW","toggle":"styles_toggle__2MSK9","preview":"styles_preview__LSnwC"};